<template>
  <div class="bbe-email-attachments" v-if="totalFiles > 0">
    <div class="bbe-email-attachments-file"
       v-for="(file, index) in attachmentsList" :key="file.id || index"
       @click="downloadFile(file)"
       @mouseleave="viewFullName = false"
       @mouseenter="viewFullName = file.id">
      <template v-if="isImage(file) && file.base64">
        <img :src="`data:${file.type};base64,${file.base64}`" class="bbe-email-attachments-file__icon"/>
      </template>
      <template v-else>
        <i class="email-icon-document bbe-email-attachments-file__icon"/>
      </template>
      <div class="bbe-email-attachments-file__name">
        {{file.name}}
        <span class="bbe-email-attachments-file__tooltip" v-if="viewFullName === file.id">
          {{file.name}}
        </span>
      </div>
      <template v-if="file.onload">
        <div class="bbe-email-attachments-file-status">
          <span class="bbe-email-attachments-file-status__progress
                       bbe-email-attachments-file-status__progress_infinity"/>
        </div>
      </template>
      <template v-else>
        <div class="bbe-email-attachments-file__size" ref="bbeStatusUpload">
          {{convertSizeFile(file.size)}}
        </div>
      </template>
    </div>
    <div class="bbe-email-attachments-download"
       @mouseleave="downloadIcon = 'email-icon-download'"
       @mouseenter="downloadIcon = 'email-icon-download-active'"
       @click="downloadsAllFiles()">
      <i :class="downloadIcon" class="bbe-email-attachments-download__icon"/>
    </div>
  </div>
</template>

<script>
import convertSizeFile from '@/mixin/convertSizeFile'
import saveAs from 'file-saver'
import b64toBlob from 'b64-to-blob'
import {get} from 'lodash'
import JSZip from 'jszip'

export default {
  name: 'EmailAttachments',
  props: ['attachments', 'totalFiles', 'placeholder'],
  mixins: [convertSizeFile],
  data () {
    return {
      downloadIcon: 'email-icon-download',
      viewFullName: '',
      progress: false,
      zipBase64: '',
      downloadFiles: 0
    }
  },
  computed: {
    attachmentsZip: {
      get: function () {
        return this.$store.getters.attachmentsZip
      },
      set: function (data) {
        this.$store.dispatch('setAttachmentsZip', data)
      }
    },
    attachmentsList () {
      const uploaded = this.attachments.length === this.totalFiles
      return uploaded && this.progress ? this.attachments : this.placeholder
    },
    activeEmail () {
      return this.$store.getters.activeEmail
    }
  },
  methods: {
    generateZip () {
      this.zipBase64 = ''
      const threadId = get(this.activeEmail, 'id', {})
      if (this.attachmentsZip[threadId]) {
        this.zipBase64 = this.attachmentsZip[threadId]
        this.downloadZip()
        return
      }
      const zip = new JSZip()
      this.attachmentsList.forEach(file => {
        zip.file(file.name, file.base64, {base64: true})
      })
      zip.generateAsync({type: 'base64'})
        .then((readyZip) => {
          this.attachmentsZip[threadId] = readyZip
          this.zipBase64 = readyZip
          this.downloadZip()
        })
    },
    downloadsAllFiles () {
      let downloadedFile = 0
      this.attachmentsList.forEach((file) => {
        this.$emit('downloadFile', file, () => {
          downloadedFile += 1
          if (downloadedFile === this.totalFiles) {
            this.generateZip()
          }
        })
      })
    },
    downloadZip () {
      const type = 'application/zip'
      const blob = b64toBlob(this.zipBase64, type)
      const name = this.generateNameZip()
      saveAs(blob, name)
    },
    setLink (file) {
      const blob = b64toBlob(file.base64, file.type)
      saveAs(blob, file.name)
      this.$set(file, 'onload', false)
    },
    downloadFile (file) {
      if (file.base64) {
        this.setLink(file)
        return
      }
      this.$set(file, 'onload', true)
      this.$emit('downloadFile', file, () => {
        this.setLink(file)
      })
    },
    isImage (file) {
      return /image/gmi.test(file.type)
    },
    generateNameZip () {
      const subject = (this.activeEmail.subject).toLowerCase()
      return `${subject}.zip`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Email/EmailAttachments/EmailAttachments.vue